export default __webpack_public_path__ + "static/arrow-faq-dbb2448c981450f82dfbd4d4da5db5e7.png";